import { Injectable } from '@angular/core';
import { AbstractAnnotationStore2D } from '../../annotation-shared/state/root/abstract-annotation-store-2d';
import { ImageAnnotationState } from './image-annotation-state';

@Injectable()
export class ImageAnnotationStore extends AbstractAnnotationStore2D<ImageAnnotationState> {
  constructor() {
    super(new ImageAnnotationState());
  }
}
